module.exports = __webpack_public_path__ + "static/img/bg_3.2d55f77.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_3.png
// module id = 785
// module chunks = 1